import { render, staticRenderFns } from "./CgShelvesManage.vue?vue&type=template&id=53d120b6&scoped=true"
import script from "./CgShelvesManage.vue?vue&type=script&lang=js"
export * from "./CgShelvesManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d120b6",
  null
  
)

export default component.exports